import { getClient } from "@sentry/react";

/**
 * Вызывать перед отправкой отзыва клиента.
 *
 * При replaysSessionSampleRate < 1 большинство сессий не пишутся с начала —
 * вместо этого (пока replaysOnErrorSampleRate > 0) SDK держит скользящий
 * буфер на случай ошибки. Важно: буфер жёстко ограничен последними ~60
 * секундами (BUFFER_CHECKOUT_TIME в @sentry/replay — каждые 60с буфер
 * полностью очищается) — это НЕ вся сессия с начала заполнения анкеты,
 * а только то, что происходило прямо перед вызовом flush().
 *
 * Если сессия и так писалась с начала (session-режим, сессию засемплировало),
 * flush() безвреден — просто подтверждает отправку уже копящихся данных.
 */
export const flushSentryReplay = (): void => {
  try {
    const client = getClient();
    const replay = client?.getIntegrationByName?.("Replay") as
      | { flush?: () => Promise<void> }
      | undefined;

    replay?.flush?.()?.catch(() => {
    });
  } catch {
  }
};
